import NotFound from '../components/404.vue'
import Login from '../components/views/login/Login.vue'
import ForgotPassword from '../components/views/login/ForgotPassword.vue'
import ResetPassword from '../components/views/login/ResetPassword.vue'
import TermsConditions from '../components/TermsConditions.vue'
import PrivacyPolicy from '../components/PrivacyPolicy.vue'

import mainRoutes from './main.route'

const routes = [
    ...mainRoutes,
    {
        path: '/login',
        component: Login,
        name: 'Login',
        meta: { requiresUnauth: true }
    },
    {
        path: '/login/forgot',
        component: ForgotPassword,
        name: 'ForgotPassword',
        meta: { requiresUnauth: true }
    },
    {
        path: '/forgot-pass-callback',
        component: ResetPassword,
        name: 'ResetPassword'
    },
    {
        path: '/privacy-policy',
        component: PrivacyPolicy,
        name: 'PrivacyPolicy',
        meta: {description: 'List of Think Gas Trips',
        title: 'Trips',}

    },
    {
        path: '/terms-conditions',
        component: TermsConditions,
        name: 'TermsConditions',
        meta: {description: 'List of Think Gas Trips',
        title: 'Trips',}

    },
    {
        // not found handler
        path: '*',
        component: NotFound
    },
    
]

export default routes


// WEBPACK FOOTER //
// ./src/routes/index.js